import React from 'react';
import Header from './components/header';
import TitleRow from './components/titlerow';
import BasicInfo from './components/basicinfo';
import HCCharts from './components/charts';
import CurrentDasa from './components/currentdasa';
import MahadasaTable from './components/mahadasa';
import EtashtakaTable from './components/etashtaka';
import PlanetDataTable from './components/planetdata';
import PlanetAspectsTable from './components/planetaspects';
import BhavaDataTable from './components/bhavadata';
import BhavaAspectsTable from './components/bhavaaspects';
import AspectPlanetTable from './components/aspectPlanet';
import AspectRashiTable from './components/aspectRashi';
import { useEffect } from 'react';
import HCViewAstakaWargaya from 'app/horoscope/components/HCViewAstakaWargaya';
import { useLocation, useNavigate } from 'react-router-dom';
import { setMiniSidenav } from 'context';
import { useMaterialUIController } from 'context';
import HeaderSettingsPopup from './components/headersettings';
import { useState } from 'react';
import './print.css';
import { IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Dasamangalalakshana from './components/dasamangalalakshana';
import HCViewDKPD from 'app/horoscope/components/HCViewDKPD';
import HCViewKPChart from 'app/horoscope/components/chart/HCViewKPChart';

const PrintRoot = () => {
    const LOCAL_STORAGE_KEY = "headerSettings";
    const [settings, setSettings] = useState({});
    const [showHeaderSettings, setShowHeaderSettings] = useState(true);
    useEffect(() => {
        const storedSettings = localStorage.getItem(LOCAL_STORAGE_KEY);
        if (storedSettings) {
            setSettings(JSON.parse(storedSettings));
        }
    }, [showHeaderSettings]);
    
    const location = useLocation();
    const horoscopeData = location.state;
        const isKpReport = horoscopeData?.req?.type === 5;
      const [controller, dispatch] = useMaterialUIController();

    const handleMiniSidenav = () => setMiniSidenav(dispatch, true);
    useEffect(() => {
        handleMiniSidenav();
        const preventSelect = (e) => e.preventDefault();
        const preventCopy = (e) => e.preventDefault();

        document.addEventListener('selectstart', preventSelect);
        document.addEventListener('copy', preventCopy);

        return () => {
            document.removeEventListener('selectstart', preventSelect);
            document.removeEventListener('copy', preventCopy);
        };
    }, []);

    const degreesToHoursMinutes = (degrees) => {
        let hours = Math.floor(degrees);
        let minutes = Math.round((degrees - hours) * 60);
        return `${hours}° ${minutes}'`;
    }

    const renderKpReportSections = () => (
        <>
            <HCViewKPChart bhavaChartData={horoscopeData.bhavaChartData}
                chatInfo={{
                    rashi: horoscopeData.lagna,
                    place: horoscopeData.lagnaSputaya,
                    latitude: degreesToHoursMinutes(horoscopeData.req.latitude) + ' ' + horoscopeData.req.latitudeDirection,
                    longitude: degreesToHoursMinutes(horoscopeData.req.longituede) + ' ' + horoscopeData.req.longitudeDirection
                }}
            />
            <div style={{ pageBreakAfter: 'always' }} />
            <BhavaDataTable bhavaData={horoscopeData.bhava} />
            <BhavaAspectsTable bhavaData={horoscopeData.bhava} />
            <PlanetAspectsTable planetData={horoscopeData.planet} />
            <div style={{ pageBreakAfter: 'always' }} />
            <div style={{ textAlign: 'left', margin: '24px 0 12px 0', fontWeight: 'bold', fontSize: '0.8em' }}>
                ග්‍රහස්ථුට
            </div>
            <PlanetDataTable planetData={horoscopeData.planet} />
            <Dasamangalalakshana data={horoscopeData} />
            <CurrentDasa dasaRecords={horoscopeData.dasa} />
            <div style={{ pageBreakAfter: 'always' }} />
            <MahadasaTable dasaRecords={horoscopeData.dasa} />
            <EtashtakaTable erashtakaRecords={horoscopeData.erashtaka} />
            <AspectPlanetTable aspectData={horoscopeData.gAspects} />
            <div style={{ pageBreakAfter: 'always' }} />
            <AspectRashiTable aspectData={horoscopeData.rAspects} />
        </>
    );

    const renderStandardReportSections = () => (
        <>
            <HCCharts horoscopeData={horoscopeData} />
            <PlanetDataTable planetData={horoscopeData.planet} />
            <div style={{ pageBreakAfter: 'always' }} />
            <Dasamangalalakshana data={horoscopeData} />
            <CurrentDasa dasaRecords={horoscopeData.dasa} />
            <MahadasaTable dasaRecords={horoscopeData.dasa} />
            <div style={{ pageBreakAfter: 'always' }} />
            <EtashtakaTable erashtakaRecords={horoscopeData.erashtaka} />
            <AspectPlanetTable aspectData={horoscopeData.gAspects} />
            <AspectRashiTable aspectData={horoscopeData.rAspects} />
            <div style={{ pageBreakAfter: 'always' }} />
            <span data-astakawarga>
                <div style={{ textAlign: 'left', margin: '24px 0 12px 0', fontWeight: 'bold', fontSize: '0.8em' }}>
                    අෂ්ටකවර්ගය
                </div>
                { horoscopeData && <HCViewAstakaWargaya astakaWargaData={horoscopeData?.astakaWarga} /> }
            </span>
        </>
    );

    const navigate = useNavigate();

    return (
        <div
            style={{
                width: '210mm',
                minHeight: '297mm',
                margin: 'auto',
                background: '#fff',
                color: '#000',
                fontFamily: 'Arial, sans-serif',
                boxSizing: 'border-box',
                padding: '4mm 2mm 4mm 8mm',
                position: 'relative'
            }}
        >
            {showHeaderSettings && <HeaderSettingsPopup open={showHeaderSettings} onClose={setShowHeaderSettings} />}
            <div className="no-print" style={{marginBottom: '24px', position: 'relative'}}>
             <IconButton
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: '30%',
                        zIndex: 10,
                        color: '#333',
                    }}
                    className="no-print"
                    title="Back"
                    onClick={() => navigate(-1)}
                >
                    <ArrowBackIcon />
                </IconButton>
            <button
                style={{
                    position: 'absolute',
                    top: 4,
                    right: '50%',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: '4px 12px 4px 8px',
                    zIndex: 10,
                    color: '#a00',
                    fontSize: '0.95em',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    // Hide button when printing
                    // Note: Inline styles don't support @media, use CSS class for print hiding
                }}
                className="no-print"
                title="Header Settings"
                onClick={() => setShowHeaderSettings(true)}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    width="20"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    style={{ display: 'inline', verticalAlign: 'middle' }}
                >
                    <path d="M19.14,12.94c0-.32,0-.65,0-1s0-.68,0-1l2.11-1.65a.5.5,0,0,0,.12-.65l-2-3.46a.5.5,0,0,0-.61-.22l-2.49,1a7,7,0,0,0-1.7-1l-.38-2.65A.5.5,0,0,0,13,2H11a.5.5,0,0,0-.5.42l-.38,2.65a7,7,0,0,0-1.7,1l-2.49-1a.5.5,0,0,0-.61.22l-2,3.46a.5.5,0,0,0,.12.65L4.86,10c0,.32,0,.65,0,1s0,.68,0,1L2.75,13.65a.5.5,0,0,0-.12.65l2,3.46a.5.5,0,0,0,.61.22l2.49-1a7,7,0,0,0,1.7,1l.38,2.65A.5.5,0,0,0,11,22h2a.5.5,0,0,0,.5-.42l.38-2.65a7,7,0,0,0,1.7-1l2.49,1a.5.5,0,0,0,.61-.22l2-3.46a.5.5,0,0,0-.12-.65ZM12,15.5A3.5,3.5,0,1,1,15.5,12,3.5,3.5,0,0,1,12,15.5Z"/>
                </svg>
                <span>Settings</span>
            </button>
            <button
                style={{
                    position: 'absolute',
                    top: 4,
                    right: '40%',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: '4px 12px 4px 8px',
                    zIndex: 10,
                    color: '#0a0',
                    fontSize: '0.95em',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    // Hide button when printing
                    // Note: Inline styles don't support @media, use CSS class for print hiding
                }}
                className="no-print"
                title="Print"
                onClick={() => window.print()}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="20"
                    width="20"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    style={{ display: 'inline', verticalAlign: 'middle' }}
                >
                    <path d="M19 8H5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v3zm0 2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h14zm-2 6v-2H7v2h10z"/>
                </svg>
                <span>Print</span>
            </button>
            </div>
            <Header
                name={settings.name}
                tele={settings.tele}
                email={settings.email}
                web={settings.web}
                address={settings.address}
                logoUrl={settings.logoUrl}
                serialNumber={settings.serialNumber}
            />
            <TitleRow dateTime={horoscopeData.req.dateTimeLocalString} name={horoscopeData.req.name} location={`${horoscopeData.req.location} | ${degreesToHoursMinutes(horoscopeData.req.latitude)} ${horoscopeData.req.latitudeDirection} / ${degreesToHoursMinutes(horoscopeData.req.longituede)} ${horoscopeData.req.longitudeDirection} | ${horoscopeData.req.offsetPeriodName} / ${horoscopeData.req.timeZoneId}`} />
            <BasicInfo data={horoscopeData}
            />
            {isKpReport
                ? renderKpReportSections()
                : renderStandardReportSections()
            }
        </div>
    );
}


export default PrintRoot;